import React from 'react';
import { FadeIn } from './FadeIn';
import { Brain, Moon, Smile, Zap } from 'lucide-react';
export function ResultsSection() {
  const results = [{
    icon: <Brain className="w-8 h-8" data-id="element-149" data-mp="us76346twucv" />,
    text: 'Más claridad para ordenar tus pensamientos'
  }, {
    icon: <Moon className="w-8 h-8" data-id="element-150" data-mp="14oa90c9i8x0v" />,
    text: 'Hábitos que favorecen un sueño más reparador'
  }, {
    icon: <Smile className="w-8 h-8" data-id="element-151" data-mp="70s2z978a90k" />,
    text: 'Herramientas para responder con más calma'
  }, {
    icon: <Zap className="w-8 h-8" data-id="element-152" data-mp="bytkvqsx42ag" />,
    text: 'Rutinas para apoyar una energía más estable'
  }];
  return <section className="py-20 bg-brand-forest text-white" data-id="element-153" data-mp="gxoc9h4yaz66">
      <div className="max-w-6xl mx-auto px-6" data-id="element-154" data-mp="lpfvf6ls22ma">
        <FadeIn data-id="element-155" data-mp="lq7pgczq7sag">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center mb-16 max-w-2xl mx-auto leading-tight" data-id="element-156" data-mp="lqqx90vnx0ar">
            Lo que puedes empezar a trabajar en 21 días
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 mb-16" data-id="element-157" data-mp="3pces4wc5qtu4">
          {results.map((result, index) => <FadeIn key={index} delay={0.1 * index} direction="up" data-id="element-158" data-mp="t8ahs0b05mav" data-mpi={index}>
              <div className="flex flex-col items-center text-center group" data-id="element-159" data-mp="ta3n9c9vq0ha">
                <div className="w-16 h-16 bg-white bg-opacity-10 rounded-full flex items-center justify-center text-brand-sage mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-160" data-mp="ofpnyys3j97c">
                  {result.icon}
                </div>
                <p className="font-medium text-lg px-4" data-id="element-161" data-mp="ahj1sfwiexni">{result.text}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} data-id="element-162" data-mp="5jhf7kzvkg7a">
          <div className="max-w-3xl mx-auto bg-white bg-opacity-10 rounded-full py-4 px-8 backdrop-blur-sm border border-white border-opacity-20" data-id="element-163" data-mp="5iof32vf8oy4">
            <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-6 text-brand-sage font-bold text-lg md:text-xl tracking-wide text-center" data-id="element-164" data-mp="1zwz69hzhnv72">
              <span data-id="element-165" data-mp="1uvji3h20l8kg">21 Días</span>
              <span className="hidden sm:inline opacity-50" data-id="element-166" data-mp="3pdb6jpyunahl">|</span>
              <span data-id="element-167" data-mp="3u4b32u423qjk">3 Fases</span>
              <span className="hidden sm:inline opacity-50" data-id="element-168" data-mp="3u4kywybs8rx6">|</span>
              <span data-id="element-169" data-mp="3fff1nfwi9brx">Herramientas prácticas</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}